import styles from "./remoteConfig.module.css";
import PropTypes from "prop-types";

const Unsubscribe = ({ configInfoData }) => {
  const unsubscribe = configInfoData?.unsubscribe || {};

  if (!unsubscribe) {
    return (
      <div className={styles["remote-config-info-container"]}>
        <div
          className={`${styles["item"]} ${styles["item-full"]} text-center fw-bold text-danger`}
          style={{ paddingTop: 10 }}
        >
          No unsubscribe configuration available.
        </div>
      </div>
    );
  }

  const isValidValue = (v) => {
    if (typeof v !== "string") return false;
    const trimmed = v.trim();
    if (trimmed === "") return false;
    if (trimmed.includes("#")) return false;
    return true;
  };

  const entries = Object.entries(unsubscribe);

  const replacePlaceholders = (v) => {
    if (typeof v !== "string") return v;
    let result = v;
    const apiDomainToken = "#truman_api_domain#";
    const docRepoToken = "#truman_document_repository_domain#";
    const apiVal = import.meta.env.VITE_API_URL || "";
    const docVal = import.meta.env.VITE_DOMAIN || "";
    if (result.includes(apiDomainToken))
      result = result.split(apiDomainToken).join(apiVal);
    if (result.includes(docRepoToken))
      result = result.split(docRepoToken).join(docVal);
    return result;
  };

  return (
    <div className={styles["remote-config-info-container"]}>
      {entries.length === 0 && (
        <div
          className={`${styles["item"]} ${styles["item-full"]} text-center fw-bold text-danger`}
          style={{ paddingTop: 10 }}
        >
          No unsubscribe configuration available.
        </div>
      )}

      {entries.map(([key, value]) => {
        const mapped = replacePlaceholders(value);
        const valid = isValidValue(mapped);
        return (
          <div
            key={key}
            className={`${styles["item"]} ${styles["item-full"]}`}
            style={{ paddingTop: 10, overflowWrap: "break-word" }}
          >
            <b>{key}</b>
            <div>
              {valid ? (
                <a href={mapped} target="_blank" rel="noopener noreferrer">
                  {mapped}
                </a>
              ) : (
                <span>N/A</span>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default Unsubscribe;

Unsubscribe.propTypes = {
  configInfoData: PropTypes.shape({
    unsubscribe: PropTypes.object,
  }),
};

Unsubscribe.defaultProps = {
  configInfoData: null,
};
